import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import {
    PropertyDefinition, PropertyMappingType,
} from "app/library/layout-builder";
import { AccountPasswordProps } from "./types";

export class AccountPasswordDefinitions extends CmsReactComponent<AccountPasswordProps> {
    static defaultProps = {};

    static schemaName = "account-password";

    static propertyDefinitions: PropertyDefinition[] = [{
        name: "title",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Başlık",
    },
    {
        name: "description",
        mapping: {
            type: PropertyMappingType.Textarea,
        },
        text: "Açıklama",
    },];
}
